import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { withRouter } from 'react-router-dom';

import './App.scss';

import If from '../../components/Shared/If/If';
import SessionTimer from '../../components/Shared/SessionTimer/SessionTimer';
import ModalsDisplay from '../../components/ModalsDisplay/ModalsDisplay';
import {
  FooterBeacon,
  FooterContainer,
} from '@trp-ii-ii-component-library/ii-components';
import NavigationContainer from '../Navigation/NavigationContainer';
import { moduleActions } from '../../redux/modules';
import { getCookie } from 'src/utils/dom-utils';
import config from '../../config/config';
import {
  getIsMobileParam,
  isCustomerWebViewEnabled,
  isSalesforceRep,
} from '../../redux/modules/authentication/authentication.module.selectors';
import { setSFRepEnabled } from '../../utils/funds/shared/shared-fund-notes-utility';
import {
  getHasCollegeOnly,
  getProductTypes,
} from '../../redux/modules/productTypes/productType.selectors';
import { setCookie } from '../../utils/dom-utils';
import { getCustomerSegmentName } from '../../redux/modules/user/PersonalInformation/personalInformation.selectors';
import {
  getHasRelationshipManager,
  getRelationshipManagerName,
} from '../../redux/modules/manager/relationshipManager.selectors';
import {
  getHasRetirementFunds,
  getHasTaxableFunds,
} from '../../redux/modules/funds/UserFunds/userFunds.selectors';
import { boolToYesNo } from '../../utils/utils';
import { isEmpty, isNil } from 'lodash';
import { getApplicationStatus } from '../../redux/modules/applicationData/applicationData.selectors';

require('animate.css/animate.min.css');

class Application extends Component {
  constructor(props) {
    super(props);
    this.state = {
      qualtricsUpdated: false,
    };
  }

  /**
   * Centralized support for populating required analytics for Qualtrics.
   */
  updateQualtricsAnalytics() {
    const {
      productTypes,
      personalInformation,
      customerSegment,
      hasRetirementFunds,
      hasRelationshipManager,
      hasTaxableFunds,
      relationshipManagerName,
    } = this.props;
    const {
      hasAPP,
      hasBrokerage,
      hasNAT529: hasN529,
      hasMD529: hasM529,
      hasAK529: hasA529,
    } = productTypes;
    const { age } = personalInformation.data;
    const custSeg = customerSegment;
    const hasRetirement = hasRetirementFunds;
    const hasRM = hasRelationshipManager;
    const hasTaxable = hasTaxableFunds;
    const rmName = relationshipManagerName;

    const qualtricsData = {
      age: Math.floor(age),
      custSeg: isEmpty(custSeg) || isNil(custSeg) ? 'CORE' : custSeg,
      hasAPP: boolToYesNo(hasAPP),
      hasBrokerage: boolToYesNo(hasBrokerage),
      hasA529: boolToYesNo(hasA529),
      hasM529: boolToYesNo(hasM529),
      hasN529: boolToYesNo(hasN529),
      hasRM: boolToYesNo(hasRM),
      hasRetirement: boolToYesNo(hasRetirement),
      hasTaxable: boolToYesNo(hasTaxable),
      rmName: isEmpty(rmName) || isNil(rmName) ? 'N/A' : rmName,
    };
    if (window && window.trpQualtrics) {
      const qD = {
        ...window.trpQualtrics,
        ...qualtricsData,
      };
      window.trpQualtrics = { ...qD };
    } else {
      if (window) {
        window.trpQualtrics = { ...qualtricsData };
      }
    }
  }

  checkUpdateAppMetrics() {
    const {
      applicationData,
      customerWebViewEnabled,
      userFundProductTypes: { hasRAS },
    } = this.props;
    const appData = applicationData || {};
    if (
      !appData.isLoading &&
      (appData.hasFailed || appData.isLoaded) &&
      !this.state.qualtricsUpdated
    ) {
      this.updateQualtricsAnalytics();
      this.setState({ qualtricsUpdated: true });
    }
    setSFRepEnabled(!customerWebViewEnabled && isSalesforceRep);

    window.metricsData.ras = window.metricsData.ras || {};
    window.metricsData.ras.isActive = hasRAS;
  }

  componentDidMount() {
    this.checkUpdateAppMetrics();
  }

  componentDidUpdate() {
    this.checkUpdateAppMetrics();
  }

  render() {
    const {
      isSalesforceRep,
      authentication,
      applicationData,
      children,
      customerSegment,
      hasRelationshipManager,
      hasRetirementFunds,
      hasTaxableFunds,
      personalInformation,
      relationshipManagerName,
      isMobileParam,
      productTypes,
      is529Only,
    } = this.props;
    const appData = applicationData || {};
    const appInfo =
      config.env === 'prod' ? (
        ''
      ) : (
        <div>
          {getCookie('trp-stage-routing')} {process.env.REACT_APP_VERSION}
          <span
            className="app-environment"
            onClick={() => {
              setCookie('stageval', 'True', 0);
              setCookie('trp-stage-routing', 'true', 0);
              window.location.reload();
            }}
          >
            Primary
          </span>
          <span
            className="app-environment"
            onClick={() => {
              setCookie('stageval', 'True', 1);
              setCookie('trp-stage-routing', 'true', 0);
              window.location.reload();
            }}
          >
            Stage Stageval
          </span>
          <span
            className="app-environment"
            onClick={() => {
              setCookie('trp-stage-routing', 'smp', 1);
              setCookie('stageval', 'true', 0);
              window.location.reload();
            }}
          >
            Beta 1
          </span>
          <span
            className="app-environment"
            onClick={() => {
              setCookie('trp-stage-routing', 'advice', 1);
              setCookie('stageval', 'true', 0);
              window.location.reload();
            }}
          >
            Beta 2
          </span>
          <span
            className="app-environment"
            onClick={() => {
              setCookie('trp-stage-routing', 'mod', 1);
              setCookie('stageval', 'true', 0);
              window.location.reload();
            }}
          >
            Beta 3
          </span>
          <span
            className="app-environment"
            onClick={() => {
              setCookie('trp-stage-routing', 'college', 1);
              setCookie('stageval', 'true', 0);
              window.location.reload();
            }}
          >
            Beta 4
          </span>
        </div>
      );

    return (
      <div className="app-baseContainer">
        {appInfo}
        <div className="app-appContainer">
          <If
            test={
              !appData.isLoading &&
              (appData.hasFailed || appData.isLoaded) &&
              !(authentication.isIFrame || isSalesforceRep)
            }
          >
            <NavigationContainer />
          </If>
          <div className="app-childContainer">
            {children}
            <ModalsDisplay />
          </div>
          <If
            test={
              !appData.isLoading &&
              (appData.hasFailed || appData.isLoaded) &&
              !(authentication.isIFrame || isSalesforceRep)
            }
          >
            {is529Only ? (
              <FooterContainer
                productTypes={productTypes}
                applicationData={applicationData}
                customerSegment={customerSegment}
                hasRelationshipManager={hasRelationshipManager}
                hasRetirementFunds={hasRetirementFunds}
                hasTaxableFunds={hasTaxableFunds}
                personalInformation={personalInformation}
                relationshipManagerName={relationshipManagerName}
                isMobileParam={isMobileParam}
              />
            ) : (
              <FooterBeacon
                productTypes={productTypes}
                applicationData={applicationData}
                customerSegment={customerSegment}
                hasRelationshipManager={hasRelationshipManager}
                hasRetirementFunds={hasRetirementFunds}
                hasTaxableFunds={hasTaxableFunds}
                personalInformation={personalInformation}
                relationshipManagerName={relationshipManagerName}
                isMobileParam={isMobileParam}
              />
            )}
          </If>
        </div>
        <SessionTimer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { authentication, user, language, userProductType } = state;

  return {
    isSalesforceRep: isSalesforceRep(state),
    customerWebViewEnabled: isCustomerWebViewEnabled(state),
    authentication,
    language,
    user,
    userProductType,
    applicationData: getApplicationStatus(state),
    userFundProductTypes: getProductTypes(state),
    customerSegment: getCustomerSegmentName(state),
    hasRelationshipManager: getHasRelationshipManager(state),
    hasRetirementFunds: getHasRetirementFunds(state),
    hasTaxableFunds: getHasTaxableFunds(state),
    personalInformation: state.personalInformation,
    productTypes: state.userProductTypes.entity || {},
    relationshipManagerName: getRelationshipManagerName(state),
    isMobileParam: getIsMobileParam(state),
    is529Only: getHasCollegeOnly(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(moduleActions, dispatch),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(Application);
